import Vue from "vue";
import Vuex from "vuex";

import network from "./network.module";
import auth from "./auth.module";
import gateways from "./gateways.module";
import info from "./info.module";
import update from "./update.module";
import duo from "./duo.module";
import system from "./system.module";
import audio from "./audio.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    network,
    auth,
    gateways,
    info,
    update,
    duo,
    system,
    audio
  }
});
